module.exports = __webpack_public_path__ + "roboto-thinitalic-webfont.f969fe6ae6b2ab39aea8.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-thinitalic-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto-thinitalic-webfont.svg
// module chunks = styles